/** Erreurs d'API → libellé FR choisi par le `code` (clé Tolgee `errors.<code>`, `src/i18n/`). */
import { ErrorCode } from '@/api/generated/types.gen';
import { translateErrorCode } from '@/i18n/tolgee';
import { isApiError } from './errors';

export const NETWORK_ERROR_LABEL = 'Le serveur est injoignable.';

/** Libellé FR d'une erreur d'API, ou null (⇒ repli du site d'appel). Jamais le message serveur. */
export function apiErrorLabel(error: unknown): string | null {
  if (!isApiError(error)) return null;
  if (error.code) return translateErrorCode(error.code, error.params);
  if (error.statusCode === 0) return NETWORK_ERROR_LABEL;
  if (error.statusCode === 429) return translateErrorCode(ErrorCode.RATE_LIMITED); // 429 d'un proxy, sans corps Hello
  return null;
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  return apiErrorLabel(error) ?? fallback;
}

/** Texte FR d'un code d'erreur SANS erreur en main (pré-contrôle local : taille d'un document, longueur d'une transcription). */
export function errorCodeLabel(code: ErrorCode, fallback: string): string {
  return translateErrorCode(code) ?? fallback;
}
